import React, { useState } from 'react';

import '@reach/combobox/styles.css';

import styled from 'styled-components';

import { SearchBox } from './SearchBox';
import { Heading, Tagline } from './Type';
import Button from './Button';
import { ReactComponent as IconRightArrow } from '../assets/icons/right-arrow.svg';
import { ReactComponent as IconDownArrow } from '../assets/icons/down-arrow.svg';
import { ReactComponent as IconUpArrow } from '../assets/icons/up-arrow.svg';
import { ReactComponent as IconOr } from '../assets/icons/or.svg';
import { ReactComponent as IconChev } from '../assets/icons/chev-down.svg';
import Filters from './Filters';
import { StyledSearchBox, StyledSearchBoxInner } from './Styles';
import { useWindowSize } from '../hooks';
import OnlineStockistModal from './OnlineStockistModal';

const StyledIconChev = styled(IconChev)`
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, -50%);
    width: 20px;
    height: auto;
`;

const StyledOr = styled(IconOr)`
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, -50%);
`;

export const Search = () => {
    const { width } = useWindowSize();
    const [showExtras, setShowExtras] = useState(false);

    const [showDialog, setShowDialog] = useState(false);
    const open = () => {
        window?.dataLayer?.push({
            event: 'gtmClick',
            element: {
                category: 'find a stockist',
                name: 'view online stockists', // set as constant even if the element text changes
                text: 'View our online stockists', // click text of the element clicked
            },
        });
        setShowDialog(true);
    };
    const close = () => setShowDialog(false);

    return (
        <>
            <StyledSearchBox>
                <StyledSearchBoxInner brand extraBottom textAlign="center">
                    <Heading>{width && width >= 768 ? 'Find your nearest stockist' : 'Find a stockist'}</Heading>
                    <Tagline>Search over 4,000 stockists across the UK</Tagline>

                    <SearchBox searchLabel={width && width >= 768 ? 'Find a stockist' : 'Find'} />
                    {!showExtras && (
                        <Button
                            color="link"
                            label="Show advanced options"
                            icon={<IconDownArrow />}
                            onClick={() => setShowExtras(true)}
                            alignSelf="flex-start"
                            spaceTop
                            style={{ marginTop: '24px' }}
                        />
                    )}
                </StyledSearchBoxInner>
                {showExtras && (
                    <StyledSearchBoxInner muted textAlign="left" align="flex-start">
                        <StyledIconChev />
                        <Filters />
                        <Button
                            color="link"
                            label="Hide advanced options"
                            icon={<IconUpArrow />}
                            onClick={() => setShowExtras(false)}
                            alignSelf="flex-start"
                        />
                    </StyledSearchBoxInner>
                )}
                <StyledSearchBoxInner extraTop>
                    <StyledOr />
                    <Button
                        color="outline"
                        label="View our online stockists"
                        icon={<IconRightArrow />}
                        alignSelf="center"
                        onClick={open}
                    />
                </StyledSearchBoxInner>
            </StyledSearchBox>
            <OnlineStockistModal show={showDialog} close={close} />
        </>
    );
};
